<template>
  <iframe class="ssa" id="clasIframe" name="clasIframe" allowfullscreen="true" :src="iframeUrl" frameborder="0"></iframe>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      iframeUrl: ''
    };
  },

  mounted() {
    this.sApi('gethtml', { ID: this.$route.params.ID, token: this.$store.getters.getTokenValue }).then(res => {
      if (res.code == 100) {
        this.$message({ message: '当前课程暂无', type: 'warning' });
        this.$router.go(-1);
        return;
      }
      this.iframeUrl = res.url;
      console.log(res.url);
      // console.log("hahaha");

    })
    setInterval(function () {
      var obj = document.getElementsByClassName('xl-chrome-ext-bar');
      var frame = document.getElementById('clasIframe');
      var frameDoc = frame.contentWindow.document;
      var frameObj = frameDoc.getElementsByClassName('xl-chrome-ext-bar');

      if (obj.length > 0) {
        obj[0].remove();
      }

      if (frameObj.length > 0) {
        frameObj[0].remove();
      }
    }, 500);
  },
  created() {

  },
  methods: {

  },
};
</script>

<style lang="scss" >
.ssa {
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  overflow: hidden;
  height: calc(100vh - 76px);
  float: left;
}
</style>
